import { useLocation, useOutletContext } from "react-router";
import { solutionsNavigationDataByKey } from "../data/solutionsNavigationData.tsx";
import { solutionOptionsByName } from "../data/solutionOptions.tsx";
import { SolutionEntry } from "../components/SolutionEntry.tsx";
import { Control } from "react-hook-form";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useLocalBaselineEmissionsState } from "../util/useLocalBaselineEmissionsState";
import { FuelSource } from "@labs/shared/types/FuelSource.ts";

const SolutionsBasePage = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentKey = currentPath.split("/").pop() || "";
  const currentNavigationItem = solutionsNavigationDataByKey[currentKey];
  const [baselineEmissions] = useLocalBaselineEmissionsState();
  const solutions = (currentNavigationItem.solutions || [])
    .map((solutionName) => solutionOptionsByName[solutionName])
    .filter((solution) => {
      const fuelSource = solution.targetedFuelSource as FuelSource;
      if (fuelSource === FuelSource.Carbon) return true;
      return baselineEmissions[fuelSource] > 0;
    });
  const control = useOutletContext<Control>();
  return (
    <List sx={{ padding: 0 }}>
      {solutions.map((solution) => (
        <ListItem
          key={solution.name}
          sx={{
            paddingTop: 0,
            paddingBottom: 2,
            paddingLeft: 0,
            paddingRight: 0,
            listStyleType: "none",
          }}
        >
          <SolutionEntry solution={solution} control={control} />
        </ListItem>
      ))}
    </List>
  );
};

export default SolutionsBasePage;
